<template>
  <div id="app">
    <transition>
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import { dbSubmissionsRef,dbReviewsRef,dbUserCollectionRef } from './firebaseConfig'
import { store } from './store/store.js'

export default {
  created () {
    this.$store.dispatch('setSubmissionRef', dbSubmissionsRef),
    this.$store.dispatch('setReviewsRef', dbReviewsRef)
    this.$store.dispatch('setUserCollectionRef', dbUserCollectionRef)

  }
}

</script>



<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100%;
}
body{
  padding:0;
  height: 100vh;
  margin:0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue